import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { style } from '../../utils/style.js';
import { Img } from '../Img/Img.js';
import { Text } from '../Text/Text.js';
import { TextWithIcon } from '../TextWithIcon/TextWithIcon.js';
export const DefaultFoldButton = JSX(({ className = '', label, icon, dataTheme = 'pc', disabled = false, onClick }) => (_jsx(TextWithIcon, { tag: "button", onClick: onClick, disabled: disabled, "data-theme": dataTheme, justifyContent: "center", role: "button", className: style('py-4 border border-transparent outline-none focus:border-primary-text space-x-s', disabled
        ? 'bg-main-divider text-main-disabled hover:bg-main-divider'
        : 'bg-primary-main text-white hover:bg-primary-hove', className), textNode: _jsx(Text, { size: "text-h4", children: label }), iconNode: icon ? (_jsx(Img, { image: {
            icon,
            iconVersion: 'white',
        }, className: "my-auto", width: "20", height: "20" })) : null })));
export const renderDefaultFoldButton = ({ isUnfolded, onToggle }) => {
    const labels = ['Развернуть', 'Скрыть'];
    const icons = ['ArrowDownIcon', 'ArrowUpIcon'];
    return (_jsx(DefaultFoldButton, { icon: icons[Number(isUnfolded)], label: labels[Number(isUnfolded)], onClick: onToggle }));
};
//# sourceMappingURL=DefaultFoldButton.js.map